import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _class;
import React from "react";
import styled from "styled-components";
import { getMemoizedAssets } from "./util";
import { BlockContainer } from "./index.style";
import SectionTitle from "../_components/SectionTitle";
import ConfigItem from "../_components/ConfigItem";
import loading1 from "../../assets/icons/hezro-loading2.gif";
import loading2 from "../../assets/icons/hezro-loading.gif";
import withFormOperate from "../_components/withFormOperate";
import { schemaName } from "../../utils";
var StyledConfigItem = styled(ConfigItem)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
var LoadingWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: 12px 0;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  img {\n    width: 32px;\n    height: 32px;\n  }\n"])));
var loadings = [{
  render: /*#__PURE__*/React.createElement(LoadingWrapper, null, /*#__PURE__*/React.createElement("img", {
    src: loading1,
    alt: "loading"
  }))
}, {
  render: /*#__PURE__*/React.createElement(LoadingWrapper, null, /*#__PURE__*/React.createElement("img", {
    src: loading2,
    alt: "loading"
  }))
}];
var LoadingConfig = withFormOperate(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(LoadingConfig, _React$Component);
  var _super = _createSuper(LoadingConfig);
  function LoadingConfig() {
    var _this;
    _classCallCheck(this, LoadingConfig);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.getCollapse = getMemoizedAssets(_this.props.styleCounts.collapse, "collapse");
    return _this;
  }
  _createClass(LoadingConfig, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        handleChange = _this$props.handleChange,
        schema = _this$props.schema,
        styleCounts = _this$props.styleCounts,
        value = _this$props.value;
      loadings[0].bottomTitle = "".concat(schemaName.get(schema), "\u6A21\u5F0F\u4E0B\uFF0C\u63A8\u8350\u4F7F\u7528\u8BE5\u6837\u5F0F");
      return /*#__PURE__*/React.createElement(BlockContainer, {
        id: "loading-config"
      }, /*#__PURE__*/React.createElement(SectionTitle, {
        title: "\u52A0\u8F7D",
        titleTail: "Loading"
      }), /*#__PURE__*/React.createElement(StyledConfigItem, {
        cols: 4,
        items: loadings,
        onChange: handleChange("spin"),
        defaultSelected: value.spin
      }), styleCounts.collapse && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SectionTitle, {
        title: "\u6298\u53E0\u9762\u677F",
        titleTail: "Accordion"
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        name: "collapse",
        cols: 2,
        items: this.getCollapse(schema),
        defaultSelected: value.collapse,
        onChange: handleChange("collapse")
      })));
    }
  }]);
  return LoadingConfig;
}(React.Component)) || _class;
export { LoadingConfig as default };